/*
 *
 * InitiateRefundModalV2 actions
 *
 */

import {
  DEFAULT_ACTION,
  CREATE_REFUND,
  VENDOR_DATA,
  SAVE_VENDORS_RESPONSE,
  ENABLE_LOADER,
  DISABLE_LOADER,
  MAXIMUM_REFUND_AMOUNT,
  SAVE_MAXIMUM_REFUND_AMOUNT,
  RESET_MODAL_DATA,
  INSTANT_REFUND_ELIGIBILITY,
  GET_WALLET_STATUS,
  GET_RECHARGE_ACCOUNT_DETAILS,
  UPDATE_DEFAULT_REFUND_SPEED,
  CREATE_INSTANT_REFUNDS_FREE_TRIAL_WALLET,
  OBPP_STATUS,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function createRefundAction(data) {
  return {
    type: CREATE_REFUND,
    data,
  };
}

export function getVendorDataAction(data) {
  return {
    type: VENDOR_DATA,
    data,
  };
}

export function saveVendorResponse(data) {
  return {
    type: SAVE_VENDORS_RESPONSE,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getMaximumRefundAction(data) {
  return {
    type: MAXIMUM_REFUND_AMOUNT,
    data,
  };
}

export function saveMaximumRefundAction(data) {
  return {
    type: SAVE_MAXIMUM_REFUND_AMOUNT,
    data,
  };
}

export function resetModalDataAction() {
  return {
    type: RESET_MODAL_DATA,
  };
}

export function getInstantRefundEligibilityAction(data) {
  return {
    type: INSTANT_REFUND_ELIGIBILITY,
    data,
  };
}

export function getWalletStatusAction(data) {
  return {
    type: GET_WALLET_STATUS,
    data,
  };
}

export function getRechargeAccountDetailsAction(data) {
  return {
    type: GET_RECHARGE_ACCOUNT_DETAILS,
    data,
  };
}

export function updateDefaultRefundSpeedAction(data) {
  return {
    type: UPDATE_DEFAULT_REFUND_SPEED,
    data,
  };
}

export function createInstantRefundsFreeTrialWallet(data) {
  return {
    type: CREATE_INSTANT_REFUNDS_FREE_TRIAL_WALLET,
    data,
  };
}

export function getObppStatusAction(data) {
  return {
    type: OBPP_STATUS,
    data,
  };
}
